// MLB abbreviations that differ from ESPN's CDN slug
const MLB_ABBREV_TO_ESPN: Record<string, string> = {
  AZ: 'ari',
  CWS: 'chw',
};

// Full team name → ESPN CDN slug per sport
const MLB_NAME_TO_ESPN: Record<string, string> = {
  'Arizona Diamondbacks': 'ari',
  'Atlanta Braves': 'atl',
  'Baltimore Orioles': 'bal',
  'Boston Red Sox': 'bos',
  'Chicago Cubs': 'chc',
  'Chicago White Sox': 'chw',
  'Cincinnati Reds': 'cin',
  'Cleveland Guardians': 'cle',
  'Colorado Rockies': 'col',
  'Detroit Tigers': 'det',
  'Houston Astros': 'hou',
  'Kansas City Royals': 'kc',
  'Los Angeles Angels': 'laa',
  'Los Angeles Dodgers': 'lad',
  'Miami Marlins': 'mia',
  'Milwaukee Brewers': 'mil',
  'Minnesota Twins': 'min',
  'New York Mets': 'nym',
  'New York Yankees': 'nyy',
  'Oakland Athletics': 'oak',
  'Philadelphia Phillies': 'phi',
  'Pittsburgh Pirates': 'pit',
  'San Diego Padres': 'sd',
  'San Francisco Giants': 'sf',
  'Seattle Mariners': 'sea',
  'St. Louis Cardinals': 'stl',
  'Tampa Bay Rays': 'tb',
  'Texas Rangers': 'tex',
  'Toronto Blue Jays': 'tor',
  'Washington Nationals': 'wsh',
};

const NBA_NAME_TO_ESPN: Record<string, string> = {
  'Atlanta Hawks': 'atl',
  'Boston Celtics': 'bos',
  'Brooklyn Nets': 'bkn',
  'Charlotte Hornets': 'cha',
  'Chicago Bulls': 'chi',
  'Cleveland Cavaliers': 'cle',
  'Dallas Mavericks': 'dal',
  'Denver Nuggets': 'den',
  'Detroit Pistons': 'det',
  'Golden State Warriors': 'gs',
  'Houston Rockets': 'hou',
  'Indiana Pacers': 'ind',
  'LA Clippers': 'lac',
  'Los Angeles Clippers': 'lac',
  'Los Angeles Lakers': 'lal',
  'Memphis Grizzlies': 'mem',
  'Miami Heat': 'mia',
  'Milwaukee Bucks': 'mil',
  'Minnesota Timberwolves': 'min',
  'New Orleans Pelicans': 'no',
  'New York Knicks': 'ny',
  'Oklahoma City Thunder': 'okc',
  'Orlando Magic': 'orl',
  'Philadelphia 76ers': 'phi',
  'Phoenix Suns': 'phx',
  'Portland Trail Blazers': 'por',
  'Sacramento Kings': 'sac',
  'San Antonio Spurs': 'sa',
  'Toronto Raptors': 'tor',
  'Utah Jazz': 'utah',
  'Washington Wizards': 'wsh',
};

const WNBA_NAME_TO_ESPN: Record<string, string> = {
  'Atlanta Dream': 'atl',
  'Chicago Sky': 'chi',
  'Connecticut Sun': 'conn',
  'Dallas Wings': 'dal',
  'Golden State Valkyries': 'gsv',
  'Indiana Fever': 'ind',
  'Las Vegas Aces': 'lv',
  'Los Angeles Sparks': 'la',
  'Minnesota Lynx': 'min',
  'New York Liberty': 'ny',
  'Phoenix Mercury': 'phx',
  'Seattle Storm': 'sea',
  'Washington Mystics': 'wsh',
};

const NFL_NAME_TO_ESPN: Record<string, string> = {
  'Arizona Cardinals': 'ari',
  'Atlanta Falcons': 'atl',
  'Baltimore Ravens': 'bal',
  'Buffalo Bills': 'buf',
  'Carolina Panthers': 'car',
  'Chicago Bears': 'chi',
  'Cincinnati Bengals': 'cin',
  'Cleveland Browns': 'cle',
  'Dallas Cowboys': 'dal',
  'Denver Broncos': 'den',
  'Detroit Lions': 'det',
  'Green Bay Packers': 'gb',
  'Houston Texans': 'hou',
  'Indianapolis Colts': 'ind',
  'Jacksonville Jaguars': 'jax',
  'Kansas City Chiefs': 'kc',
  'Las Vegas Raiders': 'lv',
  'Los Angeles Chargers': 'lac',
  'Los Angeles Rams': 'lar',
  'Miami Dolphins': 'mia',
  'Minnesota Vikings': 'min',
  'New England Patriots': 'ne',
  'New Orleans Saints': 'no',
  'New York Giants': 'nyg',
  'New York Jets': 'nyj',
  'Philadelphia Eagles': 'phi',
  'Pittsburgh Steelers': 'pit',
  'San Francisco 49ers': 'sf',
  'Seattle Seahawks': 'sea',
  'Tampa Bay Buccaneers': 'tb',
  'Tennessee Titans': 'ten',
  'Washington Commanders': 'wsh',
};

const NAME_MAPS: Record<string, Record<string, string>> = {
  mlb: MLB_NAME_TO_ESPN,
  nba: NBA_NAME_TO_ESPN,
  wnba: WNBA_NAME_TO_ESPN,
  nfl: NFL_NAME_TO_ESPN,
};

export function logoUrlFromAbbrev(abbrev: string, leagueId = 'mlb'): string {
  const slug = leagueId === 'mlb'
    ? (MLB_ABBREV_TO_ESPN[abbrev] ?? abbrev.toLowerCase())
    : abbrev.toLowerCase();
  return `https://a.espncdn.com/i/teamlogos/${leagueId}/500/${slug}.png`;
}

export function fullNameToAbbrev(name: string): string {
  const slug = MLB_NAME_TO_ESPN[name];
  if (slug) return slug.toUpperCase();
  return name.trim().split(' ').pop()?.toUpperCase() ?? name;
}

export function logoUrlFromName(name: string, leagueId = 'mlb'): string {
  const map = NAME_MAPS[leagueId] ?? MLB_NAME_TO_ESPN;
  const slug = map[name];
  if (slug) return `https://a.espncdn.com/i/teamlogos/${leagueId}/500/${slug}.png`;
  const fallback = name.trim().toLowerCase().split(' ').pop() ?? '';
  return `https://a.espncdn.com/i/teamlogos/${leagueId}/500/${fallback}.png`;
}
